import CreationToolOutputType from 'site/creation-tools/types/output-type'
import { CreationToolUploadSource } from './types'

export const getGAContent = (source: File | string, upload: CreationToolUploadSource) => {
    let contentFormat = ''
    if (typeof source === 'string') {
        contentFormat = source.split('.').pop() || ''
    } else {
        contentFormat = source.name.split('.').pop() || ''
    }

    return {
        contentFormat,
        contentType: CreationToolOutputType.title(upload.outputType),
    }
}
